module.exports = __webpack_public_path__ + "img/04.1094a53f.png";